import script from "./StartWithMcpDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StartWithMcpDialog.vue?vue&type=script&setup=true&lang=js"

import "./StartWithMcpDialog.vue?vue&type=style&index=0&id=4dc14c2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc14c2c"]])

export default __exports__